import { useWorkspace } from "./src/hooks/useWorkspace.js";
import { state } from "./src/state/workspaceStore.js";
import { getWorkspaceSession as getSession } from "./src/utils/domain/workspace.js";
import DashboardPage from "./src/pages/DashboardPage.jsx";
import ProductsPage from "./src/pages/ProductsPage.jsx";
import CollectionsPage from "./src/pages/CollectionsPage.jsx";
import OrdersPage from "./src/pages/OrdersPage.jsx";
import PaymentsPage from "./src/pages/PaymentsPage.jsx";
import CustomersPage from "./src/pages/CustomersPage.jsx";
import CouponsPage from "./src/pages/CouponsPage.jsx";
import SettingsPage from "./src/pages/SettingsPage.jsx";
import ProfilePage from "./src/pages/ProfilePage.jsx";
import NotificationsPage from "./src/pages/NotificationsPage.jsx";
import ProductDetailsPage from "./src/pages/ProductDetailsPage.jsx";
import ProductFormPage from "./src/pages/ProductFormPage.jsx";
import CollectionDetailsPage from "./src/pages/CollectionDetailsPage.jsx";
import CollectionFormPage from "./src/pages/CollectionFormPage.jsx";
import OrderDetailsPage from "./src/pages/OrderDetailsPage.jsx";
import OrderFormPage from "./src/pages/OrderFormPage.jsx";
import PaymentDetailsPage from "./src/pages/PaymentDetailsPage.jsx";
import CustomerDetailsPage from "./src/pages/CustomerDetailsPage.jsx";
import CustomerFormPage from "./src/pages/CustomerFormPage.jsx";
import CouponFormPage from "./src/pages/CouponFormPage.jsx";
import NotFoundPage from "./src/pages/NotFoundPage.jsx";
import {
  handleClick,
  handleInput,
  handleChange,
  handleSubmit,
  handleKeyDown,
} from "./src/state/uiActions.js";
import AppLayout from "./src/components/layout/AppLayout.jsx";
import LoginPage from "./src/pages/LoginPage.jsx";
import { ActionDialog } from "./src/components/dialogs/ActionDialog.jsx";
export default function App() {
  useWorkspace();
  if (state.signedIn && !getSession(localStorage, sessionStorage)) {
    state.signedIn = false;
    state.activeAccount = null;
    state.current = {
      route: "login",
      id: null,
    };
    history.replaceState(null, "", "#login");
    state.dialog = null;
  }
  const pages = {
    dashboard: DashboardPage,
    products: ProductsPage,
    collections: CollectionsPage,
    orders: OrdersPage,
    payments: PaymentsPage,
    customers: CustomersPage,
    coupons: CouponsPage,
    settings: SettingsPage,
    profile: ProfilePage,
    notifications: NotificationsPage,
    product: ProductDetailsPage,
    "product-edit": ProductFormPage,
    collection: CollectionDetailsPage,
    "collection-edit": CollectionFormPage,
    order: OrderDetailsPage,
    "order-new": OrderFormPage,
    payment: PaymentDetailsPage,
    customer: CustomerDetailsPage,
    "customer-edit": CustomerFormPage,
    "coupon-edit": CouponFormPage,
  };
  const Page = pages[state.current.route] || NotFoundPage;
  return (
    <div
      onClick={handleClick}
      onInput={handleInput}
      onChange={handleChange}
      onSubmit={(e) => {
        if (e.target.id !== "product-form") handleSubmit(e);
      }}
      onKeyDown={handleKeyDown}
    >
      {state.signedIn ? (
        <AppLayout>
          <Page
            key={state.current.route + "|" + state.current.id}
            recordId={state.current.id}
          />
        </AppLayout>
      ) : (
        <LoginPage />
      )}
      {state.toast && (
        <div className="toast" role="status">
          {state.toast}
        </div>
      )}
      {state.dialog && (
        <ActionDialog key={state.dialog.kind + "|" + state.dialog.id} />
      )}
    </div>
  );
}
